<template>
  <div class="subscription-status-panel">
    <div class="panel-promo" v-if="subscriptionStatusState == 'promo'">
      <div class="promo-content">
        <img src="/icons/onboarding-panda-eat.svg" />
        <div class="gap-row-1xs w-100">
          <div class="qrw-heading-xl v1-grey-10-color w-100 promo-center">
            {{ $t("subscription_status_panel.promo_title") }}
          </div>
          <div class="qrw-paragraph-md-sm v1-grey-10-color w-100 promo-center">
            {{ $t("subscription_status_panel.promo_text") }}
            <span class="bold">{{ uiModeDisplayTitle }}</span>
          </div>
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="qrw-paragraph-xs w-100 v1-grey-7-color promo-center">
        {{ $t("subscription_status_panel.promo_warn") }}
      </div>
    </div>

    <div
      class="panel-body"
      v-else-if="['trial'].includes(subscriptionStatusState)"
    >
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_status") }}
        </div>
        <div class="qrw-heading-xs bold orange-4-color">
          {{ $t("subscription_status_panel.param_trial") }}
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_trial") }}
        </div>
        <div class="gap-column-2xs trial-period-days">
          <div
            class="
              qrw-label-sm
              orange-4-color
              gap-column-2xs
              pull-down
            "
            v-if="isTrialPeriodActive"
          >
            <span class="paid-days-left-title bold orange-4-color">
              {{ trialPeriodDaysLeft }}
            </span>
            <div>
              {{ $t("subscription_status_panel.days_left") }}
            </div>
          </div>
          <div class="qrw-heading-xs bold red-4-color" v-else>
            {{ $t("subscription_status_panel.trial_end") }}
          </div>
          <div
            class="qrw-label-lg gap-column-2xs pull-down"
            :class="{
              'orange-4-color': isTrialPeriodActive,
              'red-4-color': !isTrialPeriodActive,
            }"
          >
            <div>{{ trialPeriodDaysUsed }}</div>
            <div class="v1-grey-6-color">|</div>
            <div class="v1-grey-6-color">
              {{ trialPeriodTotalDays }}
            </div>
          </div>
        </div>

        <div class="trial-period-status-bar">
          <div
            class="trial-bar"
            v-for="i in trialPeriodTotalDays"
            :key="i"
            :class="{
              'orange-4-bg': i <= trialPeriodDaysUsed,
              'v1-grey-4-bg': i > trialPeriodDaysUsed,
              'red-4-bg': !isTrialPeriodActive,
            }"
          ></div>
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="qrw-paragraph-xs v1-grey-8-color" v-if="isTrialPeriodActive">
        {{ $t("subscription_status_panel.desc_trial") }}
        <span class="bold">{{ uiModeDisplayTitle }}</span>
      </div>
      <div class="qrw-paragraph-xs v1-grey-8-color" v-else>
        {{ $t("subscription_status_panel.desc_trial_end") }}
      </div>
    </div>

    <div class="panel-body" v-if="subscriptionStatusState == 'card_approval'">
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_status") }}
        </div>
        <div class="qrw-heading-xs bold orange-4-color">
          {{ $t("subscription_status_panel.status_approval") }} |
          {{ apporval_string }}
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_card") }}
        </div>
        <div class="qrw-heading-xs bold v1-grey-10-color">
          {{ formattedCardMask }}
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="qrw-paragraph-xs v1-grey-8-color">
        {{ $t("subscription_status_panel.desc_approval") }}
      </div>
    </div>

    <div class="panel-body" v-if="subscriptionStatusState == 'active'">
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_subscription") }}
        </div>
        <div class="qrw-heading-xs bold v1-grey-10-color">
          {{
            $t("subscription_status_panel.period_" + subscription.periodicity)
          }}
          | ${{ subscription.price }}.00
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_card") }}
        </div>
        <div class="qrw-heading-xs bold v1-grey-10-color">
          {{ formattedCardMask }}
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_date") }}
        </div>
        <div class="qrw-heading-xs bold v1-grey-10-color">
          {{ subscription.paid_until | formatDate }}
        </div>
      </div>
      <div class="qrw-paragraph-xs v1-grey-7-color">
        {{ $t("subscription_status_panel.desc_active") }}
      </div>
    </div>

    <div class="panel-body" v-if="subscriptionStatusState == 'failed_payment'">
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_subscription") }}
        </div>
        <div class="qrw-heading-xs bold v1-grey-10-color">
          {{
            $t("subscription_status_panel.period_" + subscription.periodicity)
          }}
          | ${{ subscription.price }}.00
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_card") }}
        </div>
        <div class="qrw-heading-xs bold v1-grey-10-color">
          {{ formattedCardMask }}
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_date") }}
        </div>
      </div>
      <div class="payment-attempts-row">
        <div
          class="w-100 gap-row-2xs"
          :class="{
            'v1-grey-6-color': !record.failed,
            'red-4-color': record.failed,
            'orange-4-color': record.next,
          }"
          v-for="(record, i) in plannedPaymentDates"
          :key="i"
        >
          <div class="qrw-label-xs">
            {{ $t("subscription_status_panel.failed_attempt_" + (i + 1)) }}
          </div>
          <div class="qrw-heading-xs bold">
            {{ record.date | formatDate }}
          </div>
        </div>
      </div>
      <div class="qrw-paragraph-xs v1-grey-8-color">
        {{ $t("subscription_status_panel.desc_failed") }}
      </div>
    </div>

    <div class="panel-body" v-else-if="subscriptionStatusState == 'paid'">
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.param_subscription") }}
        </div>
        <div class="gap-column-xs">
          <div class="qrw-heading-xs bold red-4-color w-100">
            {{ $t("subscription_status_panel.param_paid") }}
          </div>
        </div>
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="body-param">
        <div class="qrw-label-sm v1-grey-8-color">
          {{ $t("subscription_status_panel.paid_period") }}
          {{ subscription.paid_until | formatDate }}
        </div>
        <div class="gap-column-2xs trial-period-days">
          <div
            class="qrw-label-sm green-4-color gap-column-2xs pull-down"
          >
            <div class="paid-days-left-title bold green-4-color">
              {{ paidPeriodDaysLeft }}
            </div>
            <div>{{ $t("subscription_status_panel.days_left") }}</div>
          </div>
          <div
            class="qrw-label-lg green-4-color pull-down gap-column-2xs"
            :class="{
              paused: isPaidPeriodPaused,
            }"
          >
            <span>{{ paidPeriodDaysUsed }}</span>
            <span class="v1-grey-6-color">|</span>
            <span class="v1-grey-6-color">
              {{ paidPeriodTotalDays }}
            </span>
          </div>
        </div>

        <div class="trial-period-status-bar">
          <div
            class="trial-bar"
            v-for="i in paidPeriodTotalDays"
            :key="i"
            :class="{
              'green-4-bg': i <= paidPeriodDaysUsed,
              'v1-grey-4-bg': i > paidPeriodDaysUsed
            }"
          ></div>
        </div>
      </div>
      <div class="qrw-paragraph-xs v1-grey-8-color">
        {{
          $t("subscription_status_panel.desc_paid", {
            system: uiModeDisplayTitle,
          })
        }}
      </div>
      <BaseDivider color="v1-grey-3" />
      <div class="gap-column-1xs">
        <BaseButton
          variant="primary"
          color="green-5"
          size="md"
          class="nowrap"
          @click="openCheckout"
        >
          {{ $t("subscription_status_panel.btn_renew") }}
        </BaseButton>
        <BaseButton
          @click="viewInvoices"
          size="md"
          variant="secondary"
          color="v1-grey-10"
        >
          {{ $t("subscription_status_panel.btn_view_invoices") }}
        </BaseButton>
      </div>
    </div>

    <div class="ended-state-container" v-else-if="subscriptionStatusState == 'ended'">
      <div class="panel-body">
        <div class="body-param">
          <div class="qrw-label-sm v1-grey-8-color">
            {{ $t("subscription_status_panel.param_subscription") }}
          </div>
          <div class="gap-column-xs">
            <div class="qrw-heading-xs bold red-4-color w-100">
              {{ $t("subscription_status_panel.ended_title") }}
              {{ subscription.paid_until | formatDate }}
            </div>
          </div>
        </div>
        <BaseDivider color="v1-grey-3" />
        <div class="gap-column-1xs">
          <BaseButton
            variant="primary"
            color="green-5"
            size="md"
            class="nowrap"
            @click="openCheckout"
          >
            {{ $t("subscription_status_panel.btn_renew") }}
          </BaseButton>
          <BaseButton
            @click="viewInvoices"
            size="md"
            variant="secondary"
            color="v1-grey-10"
          >
            {{ $t("subscription_status_panel.btn_view_invoices") }}
          </BaseButton>
        </div>
      </div>

      <div class="end-period-block">
        <img src="/icons/crying-panda.svg" />
        <div class="gap-row-2xs">
          <div class="qrw-heading-md bold w-100 end-text">
            {{ $t("subscription_status_panel.ended_thanks") }}
          </div>
          <div class="qrw-label-lg w-100 end-text">
            {{ $t("subscription_status_panel.ended_subtitle") }}
          </div>
        </div>
      </div>
    </div>

    <!-- PANEL FOOTERS -->

    <div class="panel-footer" v-if="subscriptionStatusState == 'promo'">
      <BaseButton
        class="w-100"
        @click="startTrialPeriod"
        variant="secondary"
        color="orange-4"
        size="md"
      >
        {{ $t("subscription_status_panel.btn_trial") }}
      </BaseButton>
      <BaseButton
        @click="openCheckout"
        class="w-100"
        size="md"
        variant="primary"
        color="v1-grey-10"
        bold
      >
        {{ $t("subscription_status_panel.btn_subscribe") }}
      </BaseButton>
    </div>

    <div class="panel-footer" v-else-if="subscriptionStatusState == 'trial'">
      <div class="gap-row-xs w-100">
        <div
          class="qrw-label-xs w-100 promo-center v1-grey-8-color"
          v-if="isTrialPeriodActive"
        >
          {{ $t("subscription_status_panel.charge_later") }}
        </div>
        <BaseButton
          class="w-100"
          size="md"
          variant="primary"
          @click="openCheckout"
          color="v1-grey-10"
          bold
        >
          {{ $t("subscription_status_panel.btn_subscribe") }}
        </BaseButton>
      </div>
    </div>

    <div
      class="panel-footer"
      v-else-if="subscriptionStatusState == 'card_approval'"
    >
      <BaseButton
        @click="showCancelUI"
        class="w-100"
        size="md"
        variant="secondary"
        color="red-4"
      >
        {{ $t("subscription_status_panel.btn_cancel_approval") }}
      </BaseButton>
    </div>

    <div class="panel-footer" v-else-if="subscriptionStatusState == 'active'">
      <BaseButton
        @click="showCancelUI"
        class="w-100"
        size="md"
        variant="secondary"
        color="red-4"
      >
        {{ $t("subscription_status_panel.btn_cancel") }}
      </BaseButton>
      <BaseButton
        class="w-100"
        @click="changePaymentCard"
        size="md"
        variant="secondary"
        color="orange-4"
      >
        {{ $t("subscription_status_panel.btn_change_card") }}
      </BaseButton>
      <BaseButton
        @click="viewInvoices"
        class="w-100"
        size="md"
        variant="secondary"
        color="v1-grey-10"
      >
        {{ $t("subscription_status_panel.btn_view_invoices") }}
      </BaseButton>
    </div>

    <div
      class="panel-footer"
      v-else-if="subscriptionStatusState == 'failed_payment'"
    >
      <BaseButton
        @click="showCancelUI"
        class="w-100"
        size="md"
        variant="secondary"
        color="red-4"
      >
        {{ $t("subscription_status_panel.btn_cancel") }}
      </BaseButton>
      <BaseButton
        @click="changePaymentCard"
        class="w-100"
        size="md"
        variant="primary"
        color="orange-4"
      >
        {{ $t("subscription_status_panel.btn_change_card") }}
      </BaseButton>
    </div>

    <div
      class="panel-footer"
      v-else-if="
        subscriptionStatusState == 'paid' || subscriptionStatusState == 'ended'
      "
      v-show="false"
    >
      <div class="gap-column-xs text-center w-100 feedback-block">
        <div class="qrw-paragraph-xs bold v1-grey-8-color w-100">
          {{ $t("subscription_status_panel.feedback_text") }}
        </div>
        <BaseButton
          variant="secondary"
          size="md"
          class="nowrap"
          color="v1-grey-10"
        >
          {{ $t("subscription_status_panel.feedback_btn") }}
        </BaseButton>
      </div>
    </div>

    <!-- <DangerConfirmModal
      @confirm="cancelSubscription"
      @cancel="cancelling = false"
      :cancelButton="$t('new_store_card.reconfirm_btn_cancel')"
      :confirmButton="$t('new_store_card.reconfirm_btn_confirm')"
      v-if="cancelling"
    >
      {{
        $t("new_store_card.reconfirm_cancel", {
          mode: uiModeDisplayTitle,
        })
      }}
    </DangerConfirmModal> -->

    <DangerConfirmModal
      @confirm="cancelSubscription"
      @cancel="cancelling = null"
      v-if="cancelling"
      >{{ $t("subscription.cancel") }}</DangerConfirmModal
    >

    <SubscriptionCheckoutPopup
      :mode="mode"
      :changingCard="changing_card"
      @close="checkouting = false"
      v-if="checkouting"
    />
  </div>
</template>

<script>
import moment from "moment";

import CafeAPI from "@/api/cafe";
import SubscriptionAPI from "@/api/subscription";

import SubscriptionCheckoutPopup from "@/components/subscriptions/SubscriptionCheckoutPopup.vue";

export default {
  props: {
    mode: String,
  },
  data() {
    return {
      checkouting: false,
      changing_card: false,

      cancelling: false,
      cancel_request_sent: false,

      approval_timer: null,
      approval_poll_counter: 3,
      apporval_string: "15:00",
    };
  },
  watch: {
    subscriptionStatusState() {
      this.$emit('stateChanged', this.subscriptionStatusState)
    }
  },
  methods: {
    startTrialPeriod() {
      CafeAPI.setMode(this.cafe._id, this.mode, true).then((data) => {
        if (data.changed) {
          this.$store.dispatch("subscriptions/fetchAll", this.cafe._id);
        }
      });
    },
    changePaymentCard() {
      this.changing_card = true;
      this.checkouting = true;
    },
    openCheckout() {
      this.changing_card = false;
      this.checkouting = true;
    },

    showCancelUI() {
      if (this.cancel_request_sent) return;

      this.cancelling = true
    },

    cancelSubscription() {
      this.cancelling = false;
      this.cancel_request_sent = true;

      SubscriptionAPI.cancelSubscription(this.subscription._id)
        .then((data) => {
          this.$store.commit("subscriptions/setSingleSubscription", {
            mode: this.subscription.mode,
            subscription: data.subscription,
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "subscription_error");
        })
        .finally(() => {
          this.cancel_request_sent = false;
        });
    },

    tickApprovalTimer() {
      const diff = moment(this.subscription.card_attached_at)
        .add(15, "minutes")
        .diff(moment());

      this.apporval_string = moment.utc(diff).format("mm:ss");

      this.approval_poll_counter--;

      if (this.approval_poll_counter <= 0) {
        this.approval_poll_counter = 3;
        this.$store.dispatch("subscriptions/fetchAll", this.cafe._id);
      }
    },

    viewInvoices() {
      this.$router.push({
        name: "subscription_history",
        query: {
          from: this.mode,
        },
      });
    },

    getSubscriptionStatusState() {
      return this.subscriptionStatusState;
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.subscriptionStatusState == "card_approval") {
        this.approval_timer = setInterval(this.tickApprovalTimer, 1000);
        this.tickApprovalTimer();
      }
    }, 1000);

    this.$nextTick(() => {
      this.$emit('stateChanged', this.subscriptionStatusState)
    });
  },
  beforeDestroy() {
    clearInterval(this.approval_timer);
  },
  computed: {
    formattedCardMask() {
      if (!this.subscription || !this.subscription.attached_card_mask)
        return "";

      //example: 545708*73
      const [card_issuer, card_number] =
        this.subscription.attached_card_mask.split(" ");

      return `${card_issuer} | ${card_number.substring(
        0,
        4
      )} **** **** **${card_number.substring(7)}`;
    },

    cafe() {
      return this.$store.state.cafe;
    },

    uiModeDisplayTitle() {
      return this.$store.getters["subscriptions/getModeDisplayTitle"](
        this.mode
      );
    },

    subscription() {
      return this.$store.getters["subscriptions/all"][this.mode];
    },

    isPaidPeriodPaused() {
      return !this.cafe.modes[this.mode];
    },

    isSubscriptionPaidAtMoment() {
      return (
        !!this.subscription.paid_until &&
        moment().isBefore(this.subscription.paid_until)
      );
    },

    isTrialPeriodActive() {
      return (
        !!this.subscription.trial_period_until &&
        moment().isBefore(this.subscription.trial_period_until)
      );
    },

    trialPeriodTotalDays() {
      return this.subscription.trial_period_total_duration || 14;
    },

    trialPeriodDaysUsed() {
      return Math.min(
        this.trialPeriodTotalDays,
        this.trialPeriodTotalDays - this.trialPeriodDaysLeft
      );
    },

    trialPeriodDaysLeft() {
      return Math.round(
        moment(this.subscription.trial_period_until).diff(
          moment(),
          "days",
          true
        )
      );
    },

    paidPeriodTotalDays() {
      return moment(this.subscription.paid_until).diff(
        this.subscription.updated_at,
        "days"
      );
    },

    paidPeriodDaysLeft() {
      return Math.round(
        moment(this.subscription.paid_until).diff(moment(), "days", true)
      );
    },

    paidPeriodDaysUsed() {
      return Math.min(
        this.paidPeriodTotalDays,
        this.paidPeriodTotalDays - this.paidPeriodDaysLeft
      );
    },


    subscriptionStatusState() {
      if (!this.subscription) return null;

      if (this.subscription.liqpay_id) {
        if (
          !this.subscription.last_paid_at ||
          (this.subscription.last_paid_at && moment(this.subscription.last_paid_at).isBefore(this.subscription.card_attached_at))
        ) {
          return "card_approval";
        }

        return this.isSubscriptionPaidAtMoment ? "active" : "failed_payment";
      }

      if (this.isSubscriptionPaidAtMoment) {
        return "paid";
      }

      if (this.isTrialPeriodActive) {
        return "trial";
      }

      if (this.subscription.paid_until) return "ended";

      if (!this.subscription.trial_period_until) {
        return "promo";
      } else {
        return "trial";
      }
    },

    plannedPaymentDates() {
      const point = moment(this.subscription.paid_until);

      const result = [];

      let last_failed_index = 0;

      for (let i = 0; i < 4; i++) {
        const item = {
          date: point.toDate(),
          failed: point.isBefore(moment()),
        };

        result.push(item);

        if (item.failed) {
          last_failed_index = i;
        }

        point.add(1, "day");
      }

      result[last_failed_index + 1].next = true;

      return result;
    },
  },
  components: {
    SubscriptionCheckoutPopup,
  },
};
</script>

<style scoped>
.subscription-status-panel {
  background: var(--v1-grey-1-color);
  display: flex;
  flex-direction: column;
  width: 100%;
}

.panel-footer {
  background: var(--v1-grey-2-color);
  padding: 16px 24px;
  display: flex;
  column-gap: 8px;
}

.panel-body {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px 24px;
  height: 100%;
  overflow-y: auto;
}

.panel-promo {
  padding: 24px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  row-gap: 16px;
  height: 100%;
  overflow-y: auto;
}

.promo-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  row-gap: 24px;
  width: 100%;
}

.promo-center,
.end-text {
  text-align: center;
}

.promo-content img {
  width: 150px;
  height: 150px;
  max-width: 150px;
  max-height: 150px;
  display: block;
  min-width: 150px;
}

.body-param {
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.trial-period-days {
  justify-content: space-between;
}

.trial-period-status-bar {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
}

.trial-bar {
  border-radius: 8px;
  width: 100%;
  height: 2px;
  min-height: 2px;
}

.payment-attempts-row {
  display: flex;
  flex-direction: row;
  column-gap: 40px;
}

.feedback-block {
  display: flex;
  align-items: center;
  justify-content: center;
}

.end-period-block {
  padding: 8px 0;
  display: flex;
  align-content: center;
  align-items: center;
  flex-direction: column;
  row-gap: 16px;
  background: var(--v1-grey-2-color);
  height: 100%;
}

.end-period-block img {
  width: 190px;
  height: 88px;
  max-width: 190px;
  max-height: 88px;
  min-width: 190px;
  display: block;
}

.paused {
  opacity: 0.52;
}

.pull-down {
  display: flex;
  align-items: flex-end;
}

.ended-state-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.paid-days-left-title {
  font-size: 28px;
  line-height: 24px;
}
</style>
